import { useEffect, useState } from "react"
import { useAppDispatch, useAppSelector } from "../../../../../lib/redux/hooks"
import { GetAllLaboratory, resetGetAllLaboratoryStatus, SampleCollectionCreation, setSCCreationCloratiPerclorati, setSCCreationClormequatMepiquat, setSCCreationCollectionUnit, setSCCreationEntryProtocolId, setSCCreationEnvelopeToCustomer, setSCCreationEnvelopeToLaboratory, setSCCreationEvaluationDate, setSCCreationFirstEnvelopeToCodex, setSCCreationFosetylAl, setSCCreationGlifosate, setSCCreationIdentifierCode, setSCCreationInspectionVisitId, setSCCreationLaboratoryId, setSCCreationLotNumber, setSCCreationMaterialSampled, setSCCreationMultiresiduale, setSCCreationNote, setSCCreationOfficerId, setSCCreationOgm, setSCCreationOther, setSCCreationOtherDetail, setSCCreationPlannedSampling, setSCCreationPrinciplesFound, setSCCreationSamplingCompleted, setSCCreationSamplingDate, setSCCreationSamplingTime, setSCCreationSecondEnvelopeToCodex, setSCCreationTestReportDate, setSCCreationTestReportNumber, setSCCreationTestReportResult } from "./slice"
import { Calendar } from "../../../../../ui/molecules/calendar"
import Input from "../../../../../ui/molecules/input"
import { SingleCheckbox } from "../../../../../ui/molecules/SingleCheckbox"
import { SelectCustom } from "../../../../../ui/molecules/select"
import { OptionType, SCTestReportResultOptions } from "../../../../../utils"
import { GetAllCodexSamples, resetGetAllCodexSamplesStatus } from "../../../../gestionePrelievi/slice"
import { CodexSampleChangeStatusEnum } from "../../../../gestionePrelievi/dataService/dto"
import { ProtocolSearch } from "../../../../../ui/molecules/ProtocolSearch"
import TextArea from "../../../../../ui/molecules/textArea"
import Button from "../../../../../ui/molecules/button"
import { format } from "date-fns"

interface Props {
    close: () => void
}

export function IVGestionePrelieviAddPopup(props: Props) {
    const dispatch = useAppDispatch()
    const assignmentState = useAppSelector(state => state.assignment)
    const sampleCollectionState = useAppSelector(state => state.sampleCollection)
    const codexSampleState = useAppSelector(state => state.codexSample)
    const userState = useAppSelector(state => state.users)
    const [envelopes, setEnvelopes] = useState<OptionType[]>([])
    const [laboratories, setLaboratories] = useState<OptionType[]>([])
    const [plannedSamplingFlag, setPlannedSamplingFlag] = useState<boolean>(false)
    const [completedSamplingFlag, setCompletedSamplingFlag] = useState<boolean>(false)
    const [multiresFlag, setMultiresFlag] = useState<boolean>(false)
    const [fosetyFlag, setFosetyFlagFlag] = useState<boolean>(false)
    const [ingegnerGiacomazzi, setIngegnerGiacomazzi] = useState<boolean>(false)
    const [ogmFlag, setOgmFlag] = useState<boolean>(false)
    const [cloratiFlag, setCloratiFlag] = useState<boolean>(false)
    const [clormequatFlag, setClormequatFlag] = useState<boolean>(false)
    const [otherFlag, setOtherFlag] = useState<boolean>(false)

    useEffect(() => {
        dispatch(setSCCreationInspectionVisitId(assignmentState.inspectionVisitIdToUpdate))
        dispatch(setSCCreationOfficerId(userState.findMeResponse.id))
        dispatch(setSCCreationIdentifierCode(`${assignmentState.inspectionVisitIdToUpdate}/${assignmentState.getAssignmentByIdResponse?.year}/${(sampleCollectionState.getAllSampleCollectionResponse?.total ?? 0) + 1}`))
        dispatch(GetAllCodexSamples({
            itemsPerPage: 0,
            page: 0,
            status: CodexSampleChangeStatusEnum.CONSEGNATA
        }))
        dispatch(GetAllLaboratory({
            itemsPerPage: 0,
            page: 0
        }))
    }, [])

    useEffect(() => {
        if (codexSampleState.getAllCodexSamplesStatus === 'successfully' &&
            codexSampleState.getAllCodexSampleResponse !== undefined
        ) {
            dispatch(resetGetAllCodexSamplesStatus())
            const data = codexSampleState.getAllCodexSampleResponse.data.map(cs => {
                return {
                    value: cs.envelopNumber.toString(),
                    label: `${cs.envelopNumber}`
                } as OptionType
            })
            setEnvelopes(data)
        }
    }, [codexSampleState.getAllCodexSamplesStatus])

    useEffect(() => {
        if (sampleCollectionState.getAllLaboratoryStatus === 'successfully' &&
            sampleCollectionState.getAllLaboratoryResponse !== undefined
        ) {
            dispatch(resetGetAllLaboratoryStatus())
            const data = sampleCollectionState.getAllLaboratoryResponse.data.map(lab => {
                return {
                    value: lab.id,
                    label: `${lab.name} - ${lab.accreditationNumber}`
                } as OptionType
            })
            setLaboratories(data)
        }
    }, [sampleCollectionState.getAllLaboratoryStatus])

    useEffect(() => {
        if(sampleCollectionState.sampleCollectionCreationStatus === 'successfully') {
            props.close()        
        }
    }, [sampleCollectionState.sampleCollectionCreationStatus])

    return (
        <div>
            <div className="bg-brandPrimary-100 pr-5 pl-5 pt-4 pb-5" style={{ borderTopWidth: 1 }}>
                <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-subtitle text-left">
                        Codice di Identificazione del Verbale di Campionamento
                    </div>
                    <div className="assignment-text-bold text-left">
                        {sampleCollectionState.sampleCollectionCreationRequest.identifierCode}
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Data Prelievo
                        </div>
                        <Calendar
                            selected={sampleCollectionState.sampleCollectionCreationRequest.samplingDate}
                            onChange={(date) => dispatch(setSCCreationSamplingDate(format(new Date(date), 'yyyy-MM-dd')))}
                            onClear={(date) => dispatch(setSCCreationSamplingDate(date))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Orario Prelievo
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setSCCreationSamplingTime(text))}
                            value={sampleCollectionState.sampleCollectionCreationRequest.samplingTime}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Prelievo Previsto
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={plannedSamplingFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationPlannedSampling(value))
                                setPlannedSamplingFlag(value)
                            }}
                        />
                    </div>
                    <div style={{ display: 'flex', gap: '16px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Prelievo Effettuato
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={completedSamplingFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationSamplingCompleted(value))
                                setCompletedSamplingFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Busta 1 (da analizzare)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona busta..."
                            options={envelopes}
                            value={sampleCollectionState.sampleCollectionCreationRequest.envelopeToLaboratory}
                            onChange={(value) => dispatch(setSCCreationEnvelopeToLaboratory(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Busta 2 (consegnata all'operatore)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona busta..."
                            options={envelopes}
                            value={sampleCollectionState.sampleCollectionCreationRequest.envelopeToCustomer}
                            onChange={(value) => dispatch(setSCCreationEnvelopeToCustomer(value))}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Busta 3 (da custodire - per riesame)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona busta..."
                            options={envelopes}
                            value={sampleCollectionState.sampleCollectionCreationRequest.firstEnvelopeToCodex}
                            onChange={(value) => dispatch(setSCCreationFirstEnvelopeToCodex(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Busta 4 (da custodire - per riesame)
                        </div>
                        <SelectCustom
                            placeholder="Seleziona busta..."
                            options={envelopes}
                            value={sampleCollectionState.sampleCollectionCreationRequest.secondEnvelopeToCodex}
                            onChange={(value) => dispatch(setSCCreationSecondEnvelopeToCodex(value))}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.33' }}>
                        <div className="assignment-text-content text-left">
                            Materiale Prelevato
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setSCCreationMaterialSampled(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <div className="assignment-text-content text-left">
                            Unità di Raccolta
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setSCCreationCollectionUnit(text))}
                        />
                    </div>
                    <div style={{ flex: '0.33' }}>
                        <div className="assignment-text-content text-left">
                            Lotto N.
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setSCCreationLotNumber(text))}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <SelectCustom
                        placeholder="Seleziona laboratorio..."
                        options={laboratories}
                        value={sampleCollectionState.sampleCollectionCreationRequest.laboratoryId}
                        onChange={(value) => dispatch(setSCCreationLaboratoryId(value))}
                    />
                </div>

                <div className="pb-5 assignment-subtitle text-left">
                    Tipo di analisi
                </div>

                <div className="pb-2" style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Multiresiduale
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={multiresFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationMultiresiduale(value))
                                setMultiresFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Fosetyl-AL
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={fosetyFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationFosetylAl(value))
                                setFosetyFlagFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Glifosate
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={ingegnerGiacomazzi}
                            setChecked={(value) => {
                                dispatch(setSCCreationGlifosate(value))
                                setIngegnerGiacomazzi(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            OGM
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={ogmFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationOgm(value))
                                setOgmFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Clorati e Perclorati
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={cloratiFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationCloratiPerclorati(value))
                                setCloratiFlag(value)
                            }}
                        />
                    </div>

                    <div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                        <div className="assignment-text-content text-left">
                            Clormequat e Mepiquat
                        </div>
                        <SingleCheckbox
                            label=''
                            checked={clormequatFlag}
                            setChecked={(value) => {
                                dispatch(setSCCreationClormequatMepiquat(value))
                                setClormequatFlag(value)
                            }}
                        />
                    </div>
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '12px', alignItems: 'center', borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-text-content text-left">
                        Altro
                    </div>
                    <SingleCheckbox
                        label=''
                        checked={otherFlag}
                        setChecked={(value) => {
                            dispatch(setSCCreationOther(value))
                            setOtherFlag(value)
                        }}
                    />
                    <div style={{ flex: '1' }}>
                        <Input
                            placeholder="Specifica altro..."
                            disabled={!otherFlag}
                            onChangeText={(text) => dispatch(setSCCreationOtherDetail(text))}
                        />
                    </div>
                </div>

                <div className="pb-5 pt-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Numero Rapporto di Prova
                        </div>
                        <Input
                            onChangeText={(text) => dispatch(setSCCreationTestReportNumber(text))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Data Rapporto di Prova
                        </div>
                        <Calendar
                            selected={sampleCollectionState.sampleCollectionCreationRequest.testReportDate}
                            onChange={(date) => dispatch(setSCCreationTestReportDate(format(new Date(date), 'yyyy-MM-dd')))}
                            onClear={(date) => dispatch(setSCCreationTestReportDate(date))}
                        />
                    </div>
                </div>

                <div className="pb-5">
                    <div className="assignment-text-content text-left">
                        Protocollo
                    </div>
                    <ProtocolSearch
                        type="entry"
                        value={sampleCollectionState.sampleCollectionCreationRequest.entryProtocolId}
                        onSelect={(value) => dispatch(setSCCreationEntryProtocolId(value))}
                    />
                </div>

                <div className="pb-5" style={{ display: 'flex', gap: '24px', alignItems: 'center' }}>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Esito Rapporto di Prova
                        </div>
                        <SelectCustom
                            placeholder="Seleziona esito..."
                            options={SCTestReportResultOptions}
                            value={sampleCollectionState.sampleCollectionCreationRequest.testReportResult}
                            onChange={(value) => dispatch(setSCCreationTestReportResult(value))}
                        />
                    </div>
                    <div style={{ flex: '0.5' }}>
                        <div className="assignment-text-content text-left">
                            Data Valutazione
                        </div>
                        <Calendar 
                            selected={sampleCollectionState.sampleCollectionCreationRequest.evaluationDate}
                            onChange={(date) => dispatch(setSCCreationEvaluationDate(format(new Date(date), 'yyyy-MM-dd')))}
                            onClear={(date) => dispatch(setSCCreationEvaluationDate(date))}
                            />
                    </div>
                </div>

                <div className="pb-5">
                    <div className="assignment-text-content text-left">
                        Utente Valutazione
                    </div>
                    <div className="assignment-text-bold text-left">
                        {`${userState.findMeResponse.name} ${userState.findMeResponse.surname}`}
                    </div>
                </div>

                <div className="pb-5" style={{ borderBottom: '1px solid #d9e6e8' }}>
                    <div className="assignment-text-content text-left">
                        Principi attivi riscontrati e valori
                    </div>
                    <TextArea
                        onChangeText={(text) => dispatch(setSCCreationPrinciplesFound(text))}
                    />
                </div>

                <div className="pt-5 pb-5">
                    <div className="assignment-text-content text-left">
                        Note
                    </div>
                    <TextArea
                        onChangeText={(text) => dispatch(setSCCreationNote(text))}
                    />
                </div>
            </div>

            <div style={{ display: 'flex', justifyContent: 'flex-end', padding: 15, paddingRight: 15 }}>
                <Button
                    size="md"
                    variant="outline"
                    iconPosition="off"
                    label="Annulla"
                    color="dimgrey"
                    onClick={() => {
                        props.close();
                    }}
                />
                <div className="pl-2">
                    <Button
                        size="md"
                        variant="solid"
                        iconPosition="off"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(SampleCollectionCreation(sampleCollectionState.sampleCollectionCreationRequest))}
                    />
                </div>
            </div>
        </div>
    )
}